import { useState } from "react";
import { db } from "../firebase/config";
import { doc, getDoc } from "firebase/firestore";
import "../styles/login.css";
import bgImage from "../assets/img/login_background.png";
import toast, { Toaster } from "react-hot-toast";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const userRef = doc(db, "users", username);
      const snap = await getDoc(userRef);

      if (!snap.exists()) {
        toast.error("User tidak ditemukan");
        return;
      }

      const data = snap.data();
      if (data.password !== password) {
        toast.error("Password salah");
        return;
      }

      toast.success("Login berhasil!");
      setTimeout(() => {
        onLogin({
          username: data.username,
          role: data.role,
          company: data.company || null,
        });
      }, 2000);
    } catch (err) {}
  };

  return (
    <div
      className="login-page"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
      }}
    >
      <div className="login-container">
        <h2 className="login-title">KPI Bensco Group</h2>
        <form onSubmit={handleLogin} className="login-form">
          <input
            className="login-input"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            className="login-input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button className="login-button" type="submit">
            Masuk
          </button>
          <Toaster position="top-center" reverseOrder={false} />
        </form>
      </div>
    </div>
  );
}
